import { useEffect, useState } from "react";

/**
 * Forces a re-render at a fixed interval so that dependent values
 * (like relative timestamps "12 secs ago") update in real-time without
 * having to re-fetch from the server.
 */
export default function useTick(intervalMs = 1000) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return tick;
}
